import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';
import { SortOrder } from '../../beneficiaires/detail-beneficiaire/detail-beneficiaire.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { CenterDepartmentAjoutFormModalComponent } from '../center-department-ajout-form-modal/center-department-ajout-form-modal.component';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-list-center-department',
	templateUrl: './list-center-department.component.html',
	styleUrl: './list-center-department.component.scss'
})
export class ListCenterDepartmentComponent implements OnInit {
	centerDepartments: CenterDepartment[];
	currentPage = 0;

	sortType = 'name';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	competences: Record<string, string>;

	selectedCompetences: string[] = [];
	selectedCompetencesDisplay: string;

	user: User = null;
	isPlanif = false;

	addCenterDepartmentModalRef: BsModalRef;

	isAddable = true;
	itemsPerPage = 10;

	isListingLoading: boolean = true;

	constructor(
		private facade: FacadeService,
		private modalService: BsModalService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();

		this.getCenterDepartments();
	}

	getCenterDepartments() {
		this.isListingLoading = true;
		this.facade.centerDepartmentService
			.getAllCenterDepartmentsForUserCenter()
			.subscribe({
				next: (centerDepartments) => {
					this.centerDepartments = centerDepartments;
					this.itemsPerPage = this.centerDepartments.length >= 5 ? 10 : 5;

					this.isListingLoading = false;
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
					this.isListingLoading = false;
				}
			});
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalAjout() {
		if (this.user === null || this.user.employee.serviceCenter === null) {
			this.facade.toastService.createErrorToast(
				"Vous n'êtes pas rattaché à un centre."
			);
		} else {
			this.addCenterDepartmentModalRef = this.modalService.show(
				CenterDepartmentAjoutFormModalComponent,
				{
					class: 'modal-lg',
					backdrop: 'static'
				}
			);
			this.addCenterDepartmentModalRef.onHide.subscribe(
				(reason: string | any) => {
					this.getCenterDepartments();
				}
			);
		}
	}
}
